import { ApolloLink } from 'apollo-link';

export default new ApolloLink((operation, forward) => {
  const alefUser = JSON.parse(localStorage.getItem('alef_user'));
  const token = alefUser ? alefUser.token.access_token : null;

  operation.setContext({
    headers: {
      authorization: `Bearer ${token}` || null,
    },
    credentials: 'include',
  });

  return forward(operation);
});
